import React from 'react';
import { Toolkit } from '../../../../services/types/Toolkit';
/* eslint-disable @typescript-eslint/no-unused-vars */

interface ToolkitsContext {
  toolkits: Toolkit[];
  reload: () => void;
}

const Context = React.createContext<ToolkitsContext>({
  toolkits: [] as Toolkit[],
  reload: () => {},
});

export default Context;
